// const RuncolorConversion = () =>{
//     const colorSwatches = document.querySelectorAll('.color-swatch-manual');  
//     // console.log('Color Swatches:', colorSwatches);
//     const checkedInput = document.querySelector('variant-selects .product-form__input.Color input:checked');
//     const colorFilds = document.querySelector('variant-selects .product-form__input .form__label.Color-varinats span');
//     // console.log('Color Filds:', colorFilds);
//     if(checkedInput) {  
//       const colorName = checkedInput.getAttribute('value');
//       // console.log(" Color Name of Checked Input:", colorName );
//       if (colorFilds) {
//         colorFilds.textContent = colorName;   
//       }
//     }
//   }

//   document.body.addEventListener('click', () => {
//     let count = 0;
//     const intervalId = setInterval(() => {
//       RuncolorConversion();
//       count++;
//       if (count >= 10) {
//         clearInterval(intervalId); 
//       }
//     }, 500); 
//   });
//   RuncolorConversion();

//Open hide the Unavailable variants Aj
// Hide prices immediately on page load
// document.addEventListener('DOMContentLoaded', function() {
//   // Hide all prices first
//   document.querySelectorAll('.price-item').forEach(el => {
//     el.style.visibility = 'hidden'; 
//   });

//   // Then check country
//   fetch('https://ipapi.co/json/')
//     .then(res => res.json())
//     .then(data => {
//       const countryCode = data.country_code;

//       document.querySelectorAll('.price-item').forEach(el => {
//         if (countryCode === 'LV') {
//           el.style.display = 'none'; // Hide for Latvia
//         } else {
//           el.style.visibility = 'visible'; // Show for others
//           el.style.display = 'block';
//         }
//       });
//     })
//     .catch(error => {
//       // Show prices if error
//       document.querySelectorAll('.price-item').forEach(el => {
//         el.style.visibility = 'visible';
//         el.style.display = 'block';
//       });
//     });
// });


// One shared formatter. Number#toLocaleString builds a new Intl formatter on
// every call, and this runs for every price on the page (it was the most
// expensive theme function in a CPU profile of the homepage). A cached
// Intl.NumberFormat('en-US') produces identical output.
const EN_US_NUMBER = new Intl.NumberFormat('en-US');

function formatNairaPrice(text) {
  if (typeof text !== 'string' || !text.includes('₦')) return text;
  const number = parseFloat(text.replace('₦', '').replace(/,/g, '').trim());
  if (isNaN(number)) return text;
  return '₦' + EN_US_NUMBER.format(number);
}

// `root` limits the pass to one container. The swatch click handlers pass their
// card: on load every card's first swatch is clicked, and formatting the whole
// document on each click repeated a full-page scan once per card, per handler.
// Falls back to the document for any non-element argument (requestIdleCallback
// passes an IdleDeadline, and setTimeout callers pass nothing).
function formatPriceElements(root) {
  const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
  scope.querySelectorAll('.price-item, .actual-price, .compare-at-price, .compare_at_price, .ppp').forEach(el => {
    const formatted = formatNairaPrice(el.textContent.trim());

    if (formatted !== el.textContent) el.textContent = formatted;
  });
  formatPerUnitElements(scope);
}


function perUnitLabel(cents) {
  return '(₦' + EN_US_NUMBER.format(Math.round(cents / 100)) + '/item)';
}


function formatPerUnitElements(root) {
  const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
  scope.querySelectorAll('.price-per-unit[data-per-unit-cents]').forEach(function (el) {
    const cents = parseInt(el.getAttribute('data-per-unit-cents'), 10);
    if (cents > 0) {
      el.textContent = perUnitLabel(cents);
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  });
}


function updatePerUnitPrice(cardWrapper, swatchEl) {
  if (!cardWrapper || !swatchEl) return;
  const price_raw = parseInt(swatchEl.getAttribute('data-variant-price-raw'), 10);
  const pack_qty = parseInt(swatchEl.getAttribute('data-variant-pack'), 10);
  const cents = (pack_qty > 1 && price_raw > 0) ? Math.round(price_raw / pack_qty) : 0;
  cardWrapper.querySelectorAll('.price-per-unit').forEach(function (el) {
    el.setAttribute('data-per-unit-cents', cents);
    if (cents > 0) {
      el.textContent = perUnitLabel(cents);
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {

  (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(formatPriceElements);

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      setTimeout(formatPriceElements, 50);
    });
  }

  const productGrid = document.getElementById('ProductGridContainer');
  if (productGrid) {
    let priceFormatTimer;
    let swatchInitTimer;
    new MutationObserver(() => {
      clearTimeout(priceFormatTimer);
      priceFormatTimer = setTimeout(formatPriceElements, 150);

      clearTimeout(swatchInitTimer);
      swatchInitTimer = setTimeout(() => {
        productGrid.querySelectorAll('.card').forEach(function (card) {
          const firstSwatch = card.querySelector('.product-card__swatch:first-child');
          if (firstSwatch && !card.querySelector('.product-card__swatch.is-selected')) {
            firstSwatch.classList.add('is-selected');
            firstSwatch.click();
          }
        });
      }, 200);
    }).observe(productGrid, { childList: true, subtree: true });
  }
});


// Hide quantity selector and show Out of Stock button when product is sold out
document.addEventListener("DOMContentLoaded", () => {

  if (!window.location.pathname.includes("/products/")) return;

  //open Details & Specifications
  document.querySelectorAll('#desc input[type="checkbox"]').forEach(function (cb) {
    cb.removeAttribute('disabled');
    cb.style.pointerEvents = 'none';
    cb.style.accentColor = '#28a745';
  });
  // close Details & Specifications

  const quantityContainer = document.querySelector(".price-per-item__container");
  if (!quantityContainer) return;

  // Create Out of Stock button
  const outOfStockBtn = document.createElement("button");
  outOfStockBtn.type = "button";
  outOfStockBtn.className = "out-of-stock-btn";
  outOfStockBtn.textContent = "Out of Stock";
  outOfStockBtn.disabled = true;
  outOfStockBtn.style.display = "none";

  // Notify me button - proxies the click to the Growave back-in-stock button
  const notifyBtn = document.createElement("button");
  notifyBtn.type = "button";
  notifyBtn.className = "notify-me-btn";
  notifyBtn.setAttribute("data-theme-notify", "");
  notifyBtn.textContent = "Notify me";

  const oosActions = document.createElement("div");
  oosActions.className = "oos-actions";
  oosActions.style.display = "none";
  oosActions.append(outOfStockBtn, notifyBtn);
  quantityContainer.parentElement.insertBefore(oosActions, quantityContainer);

  // Find the app's own "Notify me" trigger (injected at runtime)
  const findAppNotifyBtn = () => {
    const widget = document.querySelector(".gw-button-widget");
    if (widget) return widget.querySelector('button, a, [role="button"]') || widget;
    const nodes = document.querySelectorAll('button, a, [role="button"]');
    for (const el of nodes) {
      if (el === notifyBtn) continue;
      const txt = (el.textContent || "").trim().toLowerCase();
      if (txt.includes("notify me") || txt.includes("notify when")) return el;
    }
    return null;
  };

  // Hide the app's button, our Notify me button replaces it visually
  const hideAppNotifyBtn = () => {
    const appBtn = findAppNotifyBtn();
    if (appBtn) appBtn.classList.add("gw-notify-proxied");
  };
  hideAppNotifyBtn();
  let hideScheduled = false;
  new MutationObserver(() => {
    if (hideScheduled) return;
    hideScheduled = true;
    requestAnimationFrame(() => { hideScheduled = false; hideAppNotifyBtn(); });
  }).observe(document.body, { childList: true, subtree: true });

  notifyBtn.addEventListener("click", () => {
    const appBtn = findAppNotifyBtn();
    if (appBtn) appBtn.click();
    else console.warn("Notify me: back-in-stock app button not found");
  });

  const updateQtyVisibility = () => {
    const submitBtn = document.querySelector(".product-form__submit");
    if (!submitBtn) return;
    const isSoldOut = submitBtn.disabled;
    quantityContainer.style.display = isSoldOut ? "none" : "";
    outOfStockBtn.style.display = isSoldOut ? "" : "none";
    oosActions.style.display = isSoldOut ? "" : "none";
  };

  updateQtyVisibility();

  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(updateQtyVisibility, 200));
  }

  const submitBtn = document.querySelector(".product-form__submit");
  if (submitBtn) {
    new MutationObserver(updateQtyVisibility).observe(submitBtn, { attributes: true });
  }
});

// document.addEventListener("DOMContentLoaded", async () => {

//   if (!window.location.pathname.includes("/products/")) return;

//   try {
//     const pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
//     if (!pathMatch) return;
//     const productUrl = '/products/' + pathMatch[1] + '.js';
//     const res = await fetch(productUrl);
//     const product = await res.json();
//     const variants = product.variants;

//     const updateUI = () => {

//       const colorCont = document.querySelector(".product-form__input.Color");
//       const sizeCont = document.querySelector(".product-form__input.Size");
//       const packCont = document.querySelector(".product-form__input.Pack");

//       //console.log("colorCont....",colorCont);
//       const colorActive = colorCont?.querySelector("input:checked")?.getAttribute("data1") || colorCont?.querySelector("input:checked")?.value;
//       const sizeActive = sizeCont?.querySelector("input:checked")?.getAttribute("data1") || sizeCont?.querySelector("input:checked")?.value;

//       const active_class =  colorCont?.querySelector("input:checked");
//       // console.log("active_class.....",active_class);
//       const activeLabel = active_class?.nextElementSibling;
//       //console.log("activeLabel.....", activeLabel);
//       colorCont?.querySelectorAll('label').forEach(label => {
//          label.classList.remove('active');
//        });
//       activeLabel?.classList.add('active');

//       if (sizeCont) {
//         const availableSizes = variants
//           .filter(v => {

//             return colorCont ? v.option1 === colorActive : true;
//           })
//           .map(v => {

//             return colorCont ? v.option2 : v.option1;
//           });

//         sizeCont.querySelectorAll("input").forEach(input => {
//           toggleElement(input, availableSizes.includes(input.value));
//         });
//       }


//       if (packCont) {
//         const availablePacks = variants
//           .filter(v => {
//             let match = true;
//             //  Color check 
//             if (colorCont) match = match && v.option1 === colorActive;

//             // Size check 
//             if (sizeCont) {
//                const sVal = colorCont ? v.option2 : v.option1;
//                match = match && sVal === sizeActive;
//             }
//             return match;
//           })
//           .map(v => {

//             if (colorCont && sizeCont) return v.option3; //  C+S+P
//             if (colorCont || sizeCont) return v.option2; //  C+P or S+P
//             return v.option1; //  Only Pack Aj
//           });

//         packCont.querySelectorAll("input").forEach(input => {
//           toggleElement(input, availablePacks.includes(input.value));
//         });
//       }

//       autoSelectAvailable();
//     };

//     const toggleElement = (input, exists) => {
//       const label = input.nextElementSibling;
//       if (label) {
//         label.style.display = exists ? "" : "none";
//         label.classList.toggle('variant-hidden', !exists);
//       }
//     };

//     const autoSelectAvailable = () => {
//       ['.Size', '.Pack'].forEach(sectionClass => {
//         const container = document.querySelector(`.product-form__input${sectionClass}`);
//         if (!container) return;

//         const activeInput = container.querySelector("input:checked");
//         const activeLabel = activeInput?.nextElementSibling;

//         if (activeLabel && activeLabel.style.display === "none") {
//           const firstAvailable = container.querySelector("input + label:not([style*='display: none'])");
//           if (firstAvailable) {
//             const inputToClick = firstAvailable.previousElementSibling;
//             inputToClick.checked = true;
//             inputToClick.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         }
//       });
//     };


//     let count = 0;
//     const runRepeatedly = () => {
//       if (count < 3) { updateUI(); count++; setTimeout(runRepeatedly, 1000); }
//     };
//     runRepeatedly();

//     document.querySelector('variant-selects, .product-form')?.addEventListener("change", () => {
//       setTimeout(updateUI, 150);
//     });

//     const observer = new MutationObserver(() => {
//         observer.disconnect(); 
//         updateUI();
//         startObserver();
//     });
//     const startObserver = () => {
//       document.querySelectorAll('.product-form__input').forEach(node => 
//         observer.observe(node, { childList: true, subtree: true, attributes: true })
//       );
//     };
//     startObserver();

//   } catch (err) {
//     console.log("Variant filter error:", err);
//   }
// });
//Close hide the Unavailable variants Aj

// document.addEventListener("DOMContentLoaded", async () => {

//   if (!window.location.pathname.includes("/products/")) return;

//   try {
//     const pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
//     if (!pathMatch) return;
//     const productUrl = '/products/' + pathMatch[1] + '.js';
//     const res = await fetch(productUrl);
//     const product = await res.json();
//     const variants = product.variants;

//     const updateUI = () => {

//       const colorCont = document.querySelector(".product-form__input.Color");
//       const sizeCont = document.querySelector(".product-form__input.Size");
//       const packCont = document.querySelector(".product-form__input.Pack");

//       const colorActive = colorCont?.querySelector("input:checked")?.getAttribute("data1") || colorCont?.querySelector("input:checked")?.value;
//       const sizeActive = sizeCont?.querySelector("input:checked")?.getAttribute("data1") || sizeCont?.querySelector("input:checked")?.value;

//       const active_class = colorCont?.querySelector("input:checked");
//       const activeLabel = active_class?.nextElementSibling;
//       colorCont?.querySelectorAll('label').forEach(label => {
//         label.classList.remove('active');
//       });
//       activeLabel?.classList.add('active');

//       if (sizeCont) {
//         const availableSizes = variants
//           .filter(v => {
//             return colorCont ? v.option1 === colorActive : true;
//           })
//           .map(v => {
//             return colorCont ? v.option2 : v.option1;
//           });

//         sizeCont.querySelectorAll("input").forEach(input => {
//           toggleElement(input, availableSizes.includes(input.value));
//         });
//       }

//       if (packCont) {
//         const availablePacks = variants
//           .filter(v => {
//             let match = true;
//             if (colorCont) match = match && v.option1 === colorActive;
//             if (sizeCont) {
//               const sVal = colorCont ? v.option2 : v.option1;
//               match = match && sVal === sizeActive;
//             }
//             return match;
//           })
//           .map(v => {
//             if (colorCont && sizeCont) return v.option3;
//             if (colorCont || sizeCont) return v.option2;
//             return v.option1;
//           });

//         packCont.querySelectorAll("input").forEach(input => {
//           toggleElement(input, availablePacks.includes(input.value));
//         });
//       }

//       autoSelectAvailable();

//       // ── LAST STEP: Hide color swatches with no color-name attribute ───────
//       const colors = document.querySelectorAll('.product-form__input .color-swatch-manual');
//       colors.forEach(color => {
//         const att = color.getAttribute('color-name');
//         if (!att) {
//           color.style.display = 'none';
//         }
//       });

//       // ── LAST STEP: Hide "No Size" sizes AFTER all other logic ────────────
//       document.querySelectorAll('.product-form__input.Size label').forEach(size => {
//         const att = size.getAttribute('option');
//         const text = size.textContent?.trim();
//         if ((att && att.trim() === 'No Size') || text === 'No Size') {
//           size.style.setProperty('display', 'none', 'important');
//           const pairedInput = size.previousElementSibling;
//           if (pairedInput?.tagName === 'INPUT') {
//             pairedInput.style.setProperty('display', 'none', 'important');
//           }
//         }
//       });
//       // ─────────────────────────────────────────────────────────────────────

//     };

//     const toggleElement = (input, exists) => {
//       const label = input.nextElementSibling;
//       if (label) {
//         label.style.display = exists ? "" : "none";
//         label.classList.toggle('variant-hidden', !exists);
//       }
//     };

//     const autoSelectAvailable = () => {
//       ['.Size', '.Pack'].forEach(sectionClass => {
//         const container = document.querySelector(`.product-form__input${sectionClass}`);
//         if (!container) return;

//         const activeInput = container.querySelector("input:checked");
//         const activeLabel = activeInput?.nextElementSibling;

//         if (activeLabel && activeLabel.style.display === "none") {
//           const firstAvailable = container.querySelector("input + label:not([style*='display: none'])");
//           if (firstAvailable) {
//             const inputToClick = firstAvailable.previousElementSibling;
//             inputToClick.checked = true;
//             inputToClick.dispatchEvent(new Event('change', { bubbles: true }));
//           }
//         }
//       });
//     };

//     let count = 0;
//     const runRepeatedly = () => {
//       if (count < 3) { updateUI(); count++; setTimeout(runRepeatedly, 1000); }
//     };
//     runRepeatedly();

//     document.querySelector('variant-selects, .product-form')?.addEventListener("change", () => {
//       setTimeout(updateUI, 150);
//     });

//     const observer = new MutationObserver(() => {
//       observer.disconnect();
//       updateUI();
//       startObserver();
//     });
//     const startObserver = () => {
//       document.querySelectorAll('.product-form__input').forEach(node =>
//         observer.observe(node, { childList: true, subtree: true, attributes: true })
//       );
//     };
//     startObserver();

//   } catch (err) {
//     console.log("Variant filter error:", err);
//   }
// });

document.addEventListener("DOMContentLoaded", () => {

  if (!window.location.pathname.includes("/products/")) return;

  try {

    const pjEl = document.getElementById('ProductJson');
    if (!pjEl) return;
    let variants = null;
    try { variants = JSON.parse(pjEl.textContent).variants; } catch (e) { }
    if (!variants) return;

    // Only variants with custom.item_status == 'Active' may be picked, matching the
    // PLP cards. product | json carries no metafields, so main-product.liquid prints
    // the Active ids separately. Two deliberate fallbacks: a missing list (an older
    // cached section, or another template reusing this script) filters nothing, and a
    // product with no Active variant at all keeps its full list rather than rendering
    // a PDP where every single option is dead.
    const activeIdsEl = document.getElementById('ActiveVariantIds');
    if (activeIdsEl) {
      try {
        const activeIds = JSON.parse(activeIdsEl.textContent);
        if (Array.isArray(activeIds)) {
          const activeSet = new Set(activeIds.map(Number));
          const activeVariants = variants.filter(v => activeSet.has(Number(v.id)));
          if (activeVariants.length) variants = activeVariants;
        }
      } catch (e) { }
    }

    const updateUI = () => {

      const colorCont = document.querySelector(".product-form__input.Color");
      const sizeCont = document.querySelector(".product-form__input.Size");
      const packCont = document.querySelector(".product-form__input.Pack");

      const colorActive = colorCont?.querySelector("input:checked")?.getAttribute("data1") || colorCont?.querySelector("input:checked")?.value;
      const sizeActive = sizeCont?.querySelector("input:checked")?.getAttribute("data1") || sizeCont?.querySelector("input:checked")?.value;

      const active_class = colorCont?.querySelector("input:checked");
      const activeLabel = active_class?.nextElementSibling;
      colorCont?.querySelectorAll('label').forEach(label => {
        label.classList.remove('active');
      });
      activeLabel?.classList.add('active');


      // A size with no Active variant left is greyed out. This is deliberately NOT
      // selection-dependent — it only drops sizes that item_status has taken off
      // sale entirely, so it never fights the size-driven narrowing below.
      if (sizeCont) {
        const activeSizes = variants.map(v => colorCont ? v.option2 : v.option1);
        sizeCont.querySelectorAll("input").forEach(input => {
          toggleElement(input, activeSizes.includes(input.getAttribute("data1") || input.value));
        });
      }

      // Size drives the picker: every size that is still on sale stays pickable,
      // and Colour is narrowed to the colours that exist for the chosen size (Pack is
      // narrowed by size + colour below). option1/option2/option3 are the admin option
      // positions (Color / Size / Pack), not the on-screen order.
      if (colorCont) {
        const availableColors = variants
          .filter(v => !sizeCont || v.option2 === sizeActive)
          .map(v => v.option1);

        colorCont.querySelectorAll("input").forEach(input => {
          toggleElement(input, availableColors.includes(input.getAttribute("data1") || input.value));
        });
      }

      if (packCont) {
        const availablePacks = variants
          .filter(v => {
            let match = true;
            if (colorCont) match = match && v.option1 === colorActive;
            if (sizeCont) {
              const sVal = colorCont ? v.option2 : v.option1;
              match = match && sVal === sizeActive;
            }
            return match;
          })
          .map(v => {
            if (colorCont && sizeCont) return v.option3;
            if (colorCont || sizeCont) return v.option2;
            return v.option1;
          });

        packCont.querySelectorAll("input").forEach(input => {
          toggleElement(input, availablePacks.includes(input.value));
        });
      }

      const optionValueOf = (v, name) => {
        if (name === 'Color') return v.option1;
        if (name === 'Size') return colorCont ? v.option2 : v.option1;
        if (colorCont && sizeCont) return v.option3;
        if (colorCont || sizeCont) return v.option2;
        return v.option1;
      };

      [['Color', colorCont], ['Size', sizeCont], ['Pack', packCont]].forEach(([name, cont]) => {
        if (!cont) return;
        const activeValues = new Set(variants.map(v => optionValueOf(v, name)));
        cont.querySelectorAll("input[type='radio']").forEach(input => {
          const node = input.closest('.color-swatch-manual-item') || input.nextElementSibling;
          if (!node) return;
          if (!activeValues.has(input.getAttribute("data1") || input.value)) {
            node.style.display = 'none';
            node.dataset.statusHidden = 'true';
          } else if (node.dataset.statusHidden) {
            node.style.display = '';
            delete node.dataset.statusHidden;
          }
        });
      });

      autoSelectAvailable();

      // With Size and Pack settled, the cascade runs back the other way: a colour
      // that doesn't stock the size + pack now selected is greyed out as well.
      //
      // Read the selection fresh here rather than reusing sizeActive - the call
      // above may have just moved the Size or Pack away from a value that no
      // longer exists, and filtering on the value it moved away from would grey
      // out colours that are perfectly pickable, including the selected one.
      // Because those two are now guaranteed to exist for the current colour, the
      // selected colour always survives this filter, so it can never fight the
      // colour-driven narrowing above.
      // if (colorCont && (sizeCont || packCont)) {
      //   const sizeSelected = sizeCont?.querySelector("input:checked")?.getAttribute("data1") || sizeCont?.querySelector("input:checked")?.value;
      //   const packSelected = packCont?.querySelector("input:checked")?.getAttribute("data1") || packCont?.querySelector("input:checked")?.value;

      //   const availableColors = variants
      //     .filter(v => {
      //       let match = true;
      //       if (sizeCont) match = match && v.option2 === sizeSelected;
      //       if (packCont) {
      //         // Pack is option3 only when Size is on the page too, the same
      //         // shifting the Pack block above accounts for.
      //         const pVal = sizeCont ? v.option3 : v.option2;
      //         match = match && pVal === packSelected;
      //       }
      //       return match;
      //     })
      //     .map(v => v.option1);

      //   colorCont.querySelectorAll("input").forEach(input => {
      //     toggleElement(input, availableColors.includes(input.getAttribute("data1") || input.value));
      //   });
      // }


      if (colorCont && window.variantMetafields) {
        const items = Array.from(colorCont.querySelectorAll('.color-swatch-manual-item'));

        // Read Size/Pack fresh — autoSelectAvailable() above may have changed them
        const checkedValue = cont => {
          const input = cont?.querySelector('input:checked');
          return input?.getAttribute('data1') || input?.value;
        };
        const sizeNow = checkedValue(sizeCont);
        const packNow = checkedValue(packCont);

        const computed = items.map(item => {
          const input = item.querySelector('.color-swatch-manual-input');
          const label = item.querySelector('.color-swatch-manual');
          const colorValue = input?.getAttribute('data1') || input?.value || '';

          // Use this colour's variant for the selected Size (+ Pack), so its
          // metafields (show_color, color_name) belong to that size, not another one.
          // Falls back to any variant of the colour.
          const sameColor = variants.filter(v => v.option1 === colorValue);
          const matchedVariant =
            sameColor.find(v =>
              (!sizeCont || !sizeNow || v.option2 === sizeNow) &&
              (!packCont || !packNow || (sizeCont ? v.option3 : v.option2) === packNow)
            ) ||
            sameColor.find(v => !sizeCont || !sizeNow || v.option2 === sizeNow) ||
            sameColor[0];
          const meta = matchedVariant ? window.variantMetafields[matchedVariant.id] : null;

          if (label && meta?.color_name) {

            const rawColor = String(meta.color_name);

            const isMarkerColor = c => {
              const key = c.toLowerCase();
              return key === '#111111' || key === '#111';
            };
            const allColors = rawColor
              .split(',')
              .map(c => c.trim())
              .filter(Boolean);

            const markerIndex = allColors.findIndex(isMarkerColor);
            const beforeColors = markerIndex === -1 ? allColors : allColors.slice(0, markerIndex);
            const afterColors = markerIndex === -1 ? [] : allColors.slice(markerIndex + 1).filter(c => !isMarkerColor(c));
            const colorList = allColors.filter(c => !isMarkerColor(c));

            // linear-gradient() needs two stops, so a lone colour is repeated.
            const gradient45 = list =>
              `linear-gradient(45deg, ${(list.length === 1 ? [list[0], list[0]] : list).join(', ')})`;

            if (beforeColors.length && afterColors.length) {
              label.style.background =
                `${gradient45(beforeColors)} top / 100% 30% no-repeat, ` +
                `${gradient45(afterColors)} bottom / 100% 70% no-repeat`;
            } else if (colorList.length > 2) {
              label.style.background = `linear-gradient(45deg, ${colorList.join(', ')})`;
            } else if (colorList.length === 2) {
              label.style.background = `linear-gradient(to bottom, ${colorList[0]} 30%, ${colorList[1]} 10%)`;
            } else {
              // Empty means the metafield held nothing but the marker — paint nothing.
              label.style.background = colorList[0] || '';
            }

            label.setAttribute('color-name', rawColor);
            label.setAttribute('option', rawColor);
          }


          const labelVisible = !label || label.style.display !== 'none';
          const badgeText = (labelVisible && meta?.show_color) ? String(meta.show_color).trim() : '';

          return { item, colorValue, badgeText, labelVisible };
        });

        // Sorted so the signature describes the swatch data only. The grouping
        // below reshuffles the DOM, and an order-sensitive signature would make
        // that reshuffle trigger another rebuild, which reshuffles again.
        const signature = computed
          .map(c => c.colorValue + ':' + c.badgeText + ':' + c.labelVisible)
          .sort()
          .join('|');

        if (colorCont.dataset.swatchGroupSignature !== signature) {
          colorCont.dataset.swatchGroupSignature = signature;


          colorCont.querySelectorAll('.color-swatch-manual-group').forEach(group => {
            group.querySelectorAll('.color-swatch-manual-item').forEach(item => {
              colorCont.insertBefore(item, group);
            });
            group.remove();
          });
          colorCont.querySelectorAll('.color-swatch-manual__badge').forEach(badge => badge.remove());


          const groups = new Map();
          computed.forEach(({ item, badgeText, labelVisible }) => {
            if (!labelVisible) return;
            if (!groups.has(badgeText)) groups.set(badgeText, []);
            groups.get(badgeText).push(item);
          });

          groups.forEach((groupItems, text) => {
            if (groupItems.length > 1) {
              const wrapper = document.createElement('div');
              wrapper.className = 'color-swatch-manual-group';
              colorCont.insertBefore(wrapper, groupItems[0]);

              if (text) {
                const heading = document.createElement('span');
                heading.className = 'color-swatch-manual__badge color-swatch-manual__badge--group';
                heading.textContent = text;
                wrapper.appendChild(heading);
              }

              const row = document.createElement('div');
              row.className = 'color-swatch-manual-group__swatches';
              wrapper.appendChild(row);

              groupItems.forEach(item => row.appendChild(item));
            } else if (text) {
              const item = groupItems[0];
              const label = item.querySelector('.color-swatch-manual');
              if (!label) return;
              const badge = document.createElement('span');
              badge.className = 'color-swatch-manual__badge';
              badge.setAttribute('att', item.querySelector('.color-swatch-manual-input')?.value || '');
              badge.textContent = text;
              label.insertAdjacentElement('afterend', badge);
            }
            // else: a single swatch with no metafield value — leave it standalone, nothing to add.
          });

          // Swatches without a show_color value go first, above the named groups
          const ungrouped = groups.get('');
          if (ungrouped) {
            const node = ungrouped.length > 1 ? ungrouped[0].closest('.color-swatch-manual-group') : ungrouped[0];
            const firstSwatch = Array.from(colorCont.children).find(el =>
              el.matches('.color-swatch-manual-item, .color-swatch-manual-group')
            );
            if (node && firstSwatch && node !== firstSwatch) colorCont.insertBefore(node, firstSwatch);
          }
        }
      }


      document.querySelectorAll('.color-swatch-manual__badge').forEach(badge => {
        const isVisible = badge.style.display !== 'none' && badge.offsetParent !== null;
        badge.classList.toggle('color-test-visible', isVisible);
      });

      let colorGroupcount = document.querySelectorAll('.color-test-visible').length;
      if (colorGroupcount == 1) {
        document.querySelectorAll('.color-swatch-manual__badge').forEach(badge => {
          badge.style.display = 'none';
        });
      }
      // console.log("colorGroup_count....", colorGroupcount);

      //  Hide color swatches with no color-name
      const colors = document.querySelectorAll('.product-form__input .color-swatch-manual');
      colors.forEach(color => {
        const att = color.getAttribute('color-name');
        if (!att) {
          color.style.display = 'none';
          const wrapper = color.closest('.product-form__input');
          if (wrapper) {
            wrapper.style.setProperty('display', 'none', 'important');
          }
        }
      });

      //  Hide entire .product-form__input.Size if all labels are "No Size"
      document.querySelectorAll('.product-form__input.Size label').forEach(size => {
        const att = size.getAttribute('option');
        const text = size.textContent?.trim();
        if ((att && att.trim() === 'No Size') || text === 'No Size') {
          const wrapper = size.closest('.product-form__input');
          if (wrapper) {
            wrapper.style.setProperty('display', 'none', 'important');
          }
        }
      });



      let productTitle = document.querySelector('.product-page .product__title .title-with-wishlist-icon h1');
      let fullTitle = productTitle.innerText;

      let parts = fullTitle.split('|');
      let cleanTitle = parts[1]?.trim() === 'No Color' ? parts[0].trim() : fullTitle.trim();

      if (productTitle) {
        productTitle.innerText = cleanTitle;
      }

      // Open Get selected variant  for Adding the UAM ID in Order
      const selectedVariant = variants.find(v => {
        let match = true;

        if (colorCont) {
          match = match && v.option1 === colorActive;
        }

        if (sizeCont) {
          const selectedSize = sizeCont.querySelector("input:checked")?.value;
          match = match && (colorCont ? v.option2 : v.option1) === selectedSize;
        }

        if (packCont) {
          const selectedPack = packCont.querySelector("input:checked")?.value;

          if (colorCont && sizeCont) {
            match = match && v.option3 === selectedPack;
          } else if (colorCont || sizeCont) {
            match = match && v.option2 === selectedPack;
          } else {
            match = match && v.option1 === selectedPack;
          }
        }

        return match;
      });

      if (selectedVariant) {
        // Update hidden variant id
        const variantInput = document.querySelector(".product-variant-id");
        if (variantInput) {
          variantInput.value = selectedVariant.id;
        }

        // Update NetSuite UOM
        const uomInput = document.querySelector(
          'input[name="properties[_netsuite_uom_id]"]'
        );

        if (uomInput) {
          uomInput.value = window.variantUom[selectedVariant.id] || "";
        }
      }
      // close Get selected variant  for Adding the UAM ID in Order
    };


    // Every option value stays in the DOM: the ones that don't exist for the current
    // selection are shown greyed out ("inactive") instead of being removed, so the
    // shopper can see the full colour / pack range at a glance.
    const toggleElement = (input, exists) => {
      input.classList.toggle('variant-unavailable-input', !exists);
      // The checked value is never disabled — autoSelectAvailable moves the selection
      // away from it first, so the form always submits an enabled option.
      input.disabled = !exists && !input.checked;

      const label = input.nextElementSibling;
      if (label) {
        label.classList.toggle('variant-unavailable', !exists);

        const badge = label.nextElementSibling;
        if (badge && badge.classList.contains('color-swatch-manual__badge')) {
          badge.classList.toggle('variant-unavailable', !exists);
        }
      }

      const item = input.closest('.color-swatch-manual-item');
      if (item) {
        item.classList.toggle('variant-unavailable', !exists);
      }
    };

    // A value is pickable when it exists for the current selection and isn't hidden
    // outright (colours without a color_name metafield are removed further down).
    const isSelectable = (input) => {
      if (input.classList.contains('variant-unavailable-input')) return false;

      const label = input.nextElementSibling;
      if (label && label.style.display === 'none') return false;

      const item = input.closest('.color-swatch-manual-item');
      if (item && item.style.display === 'none') return false;

      return true;
    };

    // Size is the driver and is never greyed out, so only the dependent
    // options need their selection moved when it stops existing.
    const autoSelectAvailable = () => {
      ['.Color', '.Pack'].forEach(sectionClass => {
        const container = document.querySelector(`.product-form__input${sectionClass}`);
        if (!container) return;

        const activeInput = container.querySelector("input:checked");

        if (activeInput && !isSelectable(activeInput)) {
          const inputToClick = Array.from(container.querySelectorAll("input[type='radio']")).find(isSelectable);
          if (inputToClick) {
            inputToClick.checked = true;
            inputToClick.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    };

    let count = 0;
    const runRepeatedly = () => {
      if (count < 3) { updateUI(); count++; setTimeout(runRepeatedly, 1000); }
    };
    runRepeatedly();

    document.querySelector('variant-selects, .product-form')?.addEventListener("change", () => {
      setTimeout(updateUI, 150);
    });

    const observer = new MutationObserver(() => {
      observer.disconnect();
      updateUI();
      startObserver();
    });
    const startObserver = () => {
      document.querySelectorAll('.product-form__input').forEach(node =>
        observer.observe(node, { childList: true, subtree: true, attributes: true })
      );
    };
    startObserver();

  } catch (err) {
    // console.log("Variant filter error:", err);
  }
});
document.addEventListener("DOMContentLoaded", () => {

  let offer = document.querySelectorAll(".card__content .card__badge.bottom.left span.sale-off");
  //console.log("Offer....",offer);
  offer?.forEach((item) => {
    item.textContent = item.textContent.replace(/(\D)(\d)/, '$1 $2');
  })

  let swatch_color = document.querySelectorAll('.card__content .product-card__swatches .product-card__swatch');
  //console.log("swatch_color.......",swatch_color);
  if (swatch_color.length > 0) {
    swatch_color.forEach((item) => {
      item?.addEventListener('click', () => {

        let promations = item.getAttribute("data-variant-promo");
        let available = item.getAttribute("data-variant-available");
        let getimage = item.getAttribute("data-variant-image")
        let getsecondimage = item.getAttribute("data-variant-image-2")
        let getlink = item.getAttribute("data-variant-url");


        let sale_price = formatNairaPrice(item.getAttribute("data-variant-price"));
        let compare_at_price = formatNairaPrice(item.getAttribute("data-variant-compare-at"));
        let variant_discount = item.getAttribute('data-variant-discount');

        //console.log("promations...",promations);
        //console.log("getimage...",getimage);
        const cardWrapper = item.closest('.product-card-wrapper');
        if (cardWrapper) {
          const priceDiv = cardWrapper.querySelector('.card__content .price');
          let set_price = cardWrapper.querySelector('.card__content .price__container .price__sale');
          let regular_price = cardWrapper.querySelector('.card__content .price__container .price__regular');

          const hasSale = compare_at_price && compare_at_price !== '₦0' && parseInt(variant_discount) > 0;

          // Toggle price--on-sale class so CSS shows/hides the right container
          if (priceDiv) {
            if (hasSale) {
              priceDiv.classList.add('price--on-sale');
            } else {
              priceDiv.classList.remove('price--on-sale');
            }
          }

          if (set_price) {
            // Show or hide the entire sale block
            set_price.style.display = hasSale ? '' : 'none';

            const price__sale_span = set_price.querySelector('.actual-price');
            if (price__sale_span) price__sale_span.innerText = sale_price;

            const compare_price = set_price.querySelector('.compare-at-price');
            if (compare_price) {
              if (hasSale) {
                compare_price.innerText = compare_at_price;
                compare_price.style.display = '';
              } else {
                compare_price.style.display = 'none';
              }
            }

            const box_percent = set_price.querySelector('.box-percent');
            if (box_percent) {
              if (hasSale) {
                box_percent.innerText = `${variant_discount}% OFF`;
                box_percent.style.display = '';
              } else {
                box_percent.style.display = 'none';
              }
            }
          }

          // Always keep regular price actual-price in sync
          if (regular_price) {
            const actual_price = regular_price.querySelector('.actual-price');
            if (actual_price) actual_price.innerText = sale_price;
          }

          // Keep the per-unit price (price ÷ pack qty) in sync on swatch change
          updatePerUnitPrice(cardWrapper, item);

          formatPriceElements(cardWrapper);
          //console.log('...set_price',set_price);
        }
        if (getimage) {
          if (cardWrapper) {
            let getmedia = cardWrapper.querySelector('.card__inner .card__media a .media .motion-reduce.jj');
            let getsecondmedia = cardWrapper.querySelector('.card__inner .card__media a .media .motion-reduce.ww');
            let geturl = cardWrapper.querySelector(".card__inner .card__media a");
            let titleurl = cardWrapper.querySelector(".card__content .card-information h3 a.full-unstyled-link");
            // console.log('titleurl....',titleurl);
            if (titleurl) {
              titleurl.href = getlink;
            }
            if (geturl) {
              geturl.href = getlink;
            }
            if (getmedia) {

              getmedia.setAttribute('src', getimage);

            }
            //  if (getsecondmedia) {
            //     const currentSrc = getsecondmedia.getAttribute('src');
            //     if (currentSrc) {
            //       getsecondmedia.setAttribute('srcset', currentSrc);
            //     }
            //     getsecondmedia.setAttribute('src', getimage);
            //   }
            if (getsecondmedia) {
              getsecondmedia.srcset = '';
              getsecondmedia.src = getsecondimage;
              getsecondmedia.srcset = `${getsecondimage} 1x`;
            }

          }
        }
        if (cardWrapper) {
          const badge = cardWrapper.querySelector('.card__badge.ttt');
          if (badge) {
            const hasPromo = promations && promations !== 'Not Promotions';
            const isSoldOut = available === 'false';
            const soldOutClass = badge.getAttribute('data-sold-out-class') || 'badge badge--bottom-left';
            let badgeHTML = '';
            if (isSoldOut) {
              badgeHTML += '<span class="' + soldOutClass + '">Sold out</span>';
            }
            if (hasPromo) {
              badgeHTML += '<span class="badge badge--bottom-left color-accent-1">' + promations + '</span>';
            }
            badge.innerHTML = badgeHTML;
            badge.style.display = badgeHTML ? 'flex' : 'none';
          }
        }
      })
    })
  }


  // Open Add the collection code Aj
  if (window.innerWidth >= 750) {
    const facetRemoves = document.querySelectorAll('#FacetsWrapperDesktop .active-facets-desktop facet-remove');
    const facetsVertical = document.querySelector('.facets-vertical.container-width');
    //console.log("Facets Vertical Element =>", facetsVertical);
    const Sort_by = document.querySelector(".facets-vertical-form ");
    const activeFacetBlock = document.querySelector("#FacetsWrapperDesktop .active-facets-desktop");
    const facet_remove = document.querySelector("#FacetsWrapperDesktop .active-facets-desktop facet-remove");
    const filter = document.querySelector("#FacetsWrapperDesktop .active-facets-desktop .active-facets-vertical-filter");
    //  console.log('.facet_remove...',facet_remove);
    // console.log('.filter.......',filter);
    // console.log('activeFacetBlock.......',activeFacetBlock);
    // console.log("Sort_by......",Sort_by);
    const clonedHTML = `
        <div class="cloned-active-facets container-width">
        <div class="filter-sort-by">
            <div class="filter-remove">
                ${filter?.outerHTML || ''}
            </div>

            <div class="facet_remove-box">
            ${activeFacetBlock?.outerHTML || ''}
            </div>

          <div class="Sort-desgin">
              ${Sort_by?.outerHTML || ''}
          </div>
        </div>
         
          <div class="facets-separator">
            <div>
        </div>
      
      `;
    if (activeFacetBlock)
      activeFacetBlock.style.display = 'none';
    facetsVertical?.insertAdjacentHTML("beforebegin", clonedHTML);

    // Sync cloned sort-by select with original so FacetFiltersForm events fire correctly.
    // The real select lives in the hidden `.facets-vertical-sort` form, a SIBLING of
    // `.facets-vertical` (not inside it) — must query that sibling, not facetsVertical.
    const clonedSortSelect = document.querySelector('.cloned-active-facets select[name="sort_by"]');
    const originalSortSelect = document.querySelector('.facets-vertical-sort select[name="sort_by"]');
    if (clonedSortSelect && originalSortSelect) {
      // Set initial value from URL param so it matches actual product order on page load
      const urlSort = new URLSearchParams(window.location.search).get('sort_by');
      clonedSortSelect.value = urlSort || originalSortSelect.value;

      // After each AJAX re-render, sync cloned select with fresh original select value
      const productGrid = document.getElementById('ProductGridContainer');
      if (productGrid) {
        new MutationObserver(() => {
          const freshSelect = document.querySelector('.facets-vertical-sort select[name="sort_by"]');
          if (freshSelect && clonedSortSelect) clonedSortSelect.value = freshSelect.value;
        }).observe(productGrid, { childList: true, subtree: false });
      }

      clonedSortSelect.addEventListener('change', (e) => {
        // Re-query each time because AJAX re-render replaces the DOM after filters are applied
        const freshOriginalSelect = document.querySelector('.facets-vertical-sort select[name="sort_by"]');
        if (freshOriginalSelect) {
          freshOriginalSelect.value = e.target.value;
          freshOriginalSelect.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }
  }
  // close Add the collection code Aj

  // open product card variants auto seleted Aj
  document.querySelectorAll('.card')?.forEach((card) => {
    const firstSwatch = card?.querySelector('.product-card__swatch');
    firstSwatch?.click();
  });
  // close product card variants auto seleted Aj

  //Open product tabs for Description  Aj
  // Tabs UI removed — Description is now a single always-visible accordion, so the
  // tab-switching + reviews show/hide-on-click logic below is disabled (kept for reference).
  /*
  const tabs = document.querySelectorAll(".product-tabs-nav li");
  const panels = document.querySelectorAll(".tab-panel");

  tabs?.forEach(tab => {
    tab?.addEventListener("click", () => {
      tabs?.forEach(t => t?.classList?.remove("active"));
      panels?.forEach(p => p?.classList?.remove("active"));
      let reviews = document.querySelector(".product-page .scroll-trigger.animate--slide-in.app-data");
      if (tab.dataset.tab === "reviews") {
        //console.log("Reviews Element =>", reviews);
        if (reviews) {
          reviews.style.display = "block";
        }
      }
      else {
        if (reviews) {
          reviews.style.display = "none";
        }
      }
      tab?.classList?.add("active");
      const target = tab?.dataset?.tab;
      // console.log("Target Tab =>", target);
      document.getElementById(target)?.classList?.add("active");
    });
  });
  */
  //Close product tabs for Description  Aj

  // Reviews widget (right after the product info) is now always visible instead of
  // being revealed only when the old "Reviews" tab was clicked.
  const reviewsWidget = document.querySelector(".product-page .scroll-trigger.animate--slide-in.app-data");
  if (reviewsWidget) {
    reviewsWidget.style.display = "block";
  }

  document.addEventListener("click", (e) => {
    const badge = e.target?.closest?.(".jdgm-prev-badge, .jdgm-preview-badge");
    if (!badge) return;
    if (!reviewsWidget) return;
    e.preventDefault();
    e.stopPropagation();
    reviewsWidget.scrollIntoView({ behavior: "smooth", block: "start" });
  }, true);


  //open product gallery variant images Aj
  const gallery = document.querySelector('.custom-product-gallery');
  if (!gallery) return;

  const getVariantIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    //console.log('Variant ID from URL:', params.get('variant'));
    return params.get('variant');
  }

  // The variant id to show on arrival: the ?variant= in the URL if present,
  // otherwise the variant that's already selected/checked on the page
  // (product.selected_or_first_available_variant, rendered into input[name="id"]).
  // This makes the selected variant's metafield images load on page load even when
  // the URL has no ?variant= param.
  const getSelectedVariantId = () => {
    return getVariantIdFromUrl()
      || document.querySelector('product-info input[name="id"]')?.value
      || null;
  }

  const buildGallery = (images) => {
    const thumbWrap = gallery.querySelector('.gallery-thumbnails');
    const mainWrap = gallery.querySelector('.gallery-main');

    if ($(thumbWrap).hasClass('slick-initialized')) $(thumbWrap).slick('unslick');
    thumbWrap.innerHTML = '';
    mainWrap.querySelectorAll('.main-image').forEach(el => el.remove());

    images.forEach((img, i) => {
      thumbWrap.insertAdjacentHTML(
        'beforeend',
        `<button class="thumbnail ${i === 0 ? 'active' : ''}" data-index="${i}">
            <img src="${img.thumb}">
          </button>`
      );

      mainWrap.insertAdjacentHTML(
        'beforeend',
        `<div class="main-image ${i === 0 ? 'active' : ''}" data-index="${i}">
            <img class="zoom-image" src="${img.main}" data-zoom="${img.zoom || img.main}">
          </div>`
      );
    });

    initGallery();
    setTimeout(() => { if (window.runsilder) window.runsilder(); }, 50);
  }

  const initGallery = () => {
    const thumbs = gallery.querySelectorAll('.thumbnail');
    const mains = gallery.querySelectorAll('.main-image');
    const prev = gallery.querySelector('.gallery-arrow.prev');
    const next = gallery.querySelector('.gallery-arrow.next');

    let current = 0;

    const update = (i) => {
      thumbs.forEach(t => t.classList.remove('active'));
      mains.forEach(m => m.classList.remove('active'));

      thumbs[i]?.classList.add('active');
      mains[i]?.classList.add('active');
      current = i;
    };

    thumbs.forEach((t, i) => t.onclick = () => update(i));

    prev?.addEventListener('click', () =>
      update(current === 0 ? thumbs.length - 1 : current - 1)
    );

    next?.addEventListener('click', () =>
      update(current === thumbs.length - 1 ? 0 : current + 1)
    );

    update(0);
  }

  // Shown when the selected variant has no images in its custom.variants_images metafield.
  const NO_IMAGE_SRC = 'https://cdn.shopify.com/s/files/1/0982/7034/7445/files/noimage.gif?v=1768217749';

  let lastVariant = null;

  const updateGalleryForVariant = (variantId) => {
    if (!variantId || String(variantId) === lastVariant) return;
    lastVariant = String(variantId);

    const imgs = window.variantImagesMap?.[lastVariant];

    if (imgs && imgs.length) {
      buildGallery(imgs);
    } else {
      // No metafield image for this variant -> show the "No image" placeholder
      // instead of falling back to the product media.
      buildGallery([{ thumb: NO_IMAGE_SRC, main: NO_IMAGE_SRC, zoom: NO_IMAGE_SRC }]);
    }
  };


  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      if (variant?.id) updateGalleryForVariant(variant.id);
    });
  }


  setInterval(() => {
    const variantId = getVariantIdFromUrl();
    if (variantId) updateGalleryForVariant(variantId);
  }, 300);

  initGallery();
  const initialVariant = getSelectedVariantId();
  if (initialVariant) updateGalleryForVariant(initialVariant);


  const productPage = document.querySelector('.product-page');

  if (productPage) {

    // const colors = document.querySelectorAll('.product-form__input .color-swatch-manual');
    // //console.log('Color Swatches:', colors);
    //   colors.forEach(color => { 
    //     const att = color.getAttribute('color-name');
    //     if(!att){
    //       color.style.display = 'none';
    //     }
    //     console.log('Color Name Attribute:', att);
    //   });

    //    const sizes = document.querySelectorAll('.product-form__input.Size label');
    //    sizes.forEach(size => {  

    //     const att = size.getAttribute('option');
    //     if (att && att.trim() === 'No Size') {
    //      size.style.setProperty('display', 'none', 'important');
    //     }
    //     console.log('Size Option Attribute:', att);
    //    });



    const priceDiv = document.querySelector(
      '.product__info-container div[role="status"]'
    );


    if (priceDiv) {
      priceDiv.classList.remove('hidden');

      const priceObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class' &&
            priceDiv.classList.contains('hidden')
          ) {
            priceDiv.classList.remove('hidden');
          }
        });
      });

      priceObserver.observe(priceDiv, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    // const RuncolorConversion = () => {
    //   const colorSwatches = document.querySelectorAll('.color-swatch-manual');
    //   const checkedInput = document.querySelector(
    //     'variant-selects .product-form__input.Color input:checked'
    //   );
    //   // const colorFilds = document.querySelector(
    //   //   'variant-selects .product-form__input .form__label.Color-varinats span'
    //   // );

    //   if (!checkedInput) return;

    //   const colorName = checkedInput.value;

    //   // if (colorFilds) {
    //   //   colorFilds.textContent = colorName;
    //   // }

    //   colorSwatches.forEach((item) => {
    //     const att = item.getAttribute('color-name');
    //     item.style.border = 'none';

    //     item.classList.remove("active");
    //     if (colorName === att) {
    //       item.classList.add("active");
    //      // item.style.border = '2px solid black';

    //     }

    //   });
    // };

    // RuncolorConversion();
    // document.body.addEventListener('click', () => {
    //   let count = 0;
    //   const intervalId = setInterval(() => {
    //     RuncolorConversion();
    //     count++;
    //     if (count >= 10) clearInterval(intervalId);
    //   }, 500);
    // });

    // Gallery syncing with thumbnail slider Aj


    document
      .querySelector('.product-page .gallery-main .gallery-arrow.next')
      ?.addEventListener('click', () => {
        document
          .querySelector('.product-page .gallery-thumbnails .slick-next')
          ?.click();
      });

    document
      .querySelector('.product-page .gallery-main .gallery-arrow.prev')
      ?.addEventListener('click', () => {
        document
          .querySelector('.product-page .gallery-thumbnails .slick-prev')
          ?.click();
      });
  }


});


$(document).ready(function () {

  function checkAndInitSlider(selector, parentSelector) {
    var $slider = $(selector);
    var $parent = $(parentSelector);
    var totalProducts = $slider.children('li').length;

    function checkClass() {
      var windowWidth = $(window).width();

      if (windowWidth >= 1024 && totalProducts > 5) {

        $slider.addClass('Aj');
        $parent.addClass('silder-width');
      } else if (windowWidth < 1024 && windowWidth >= 600 && totalProducts > 4) {
        $slider.addClass('Aj');
        $parent.addClass('silder-width');
      } else if (windowWidth < 600 && windowWidth >= 480 && totalProducts > 3) {
        $slider.addClass('Aj');
        $parent.addClass('silder-width');
      } else if (windowWidth < 480 && totalProducts > 2) {
        $slider.addClass('Aj');
        $parent.addClass('silder-width');
      } else {
        $slider.removeClass('Aj');
        $parent.removeClass('silder-width');
      }
    }

    function initSlider() {
      // slick is only loaded on templates that have slick carousels (not the
      // homepage); without this guard it threw "$(...).slick is not a function".
      checkClass();
      if (typeof $.fn.slick !== 'function') return;

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      if ($slider.hasClass('Aj')) {
        $slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 5,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }


    initSlider();

    // Debounced: re-running slick unslick/reslick on every resize tick is a major TBT/INP cost
    var _resizeTimer;
    $(window).on('resize', function () {
      clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(initSlider, 200);
    });
  }


  checkAndInitSlider('.similar-products ul.product-grid', '.similar-products');
  checkAndInitSlider('.like-products ul.product-grid', '.like-products');

});
// Slider for related products Aj
$(document).ready(function () {

  function runsilder() {
    // slick is only loaded on templates that have slick carousels (not the
    // homepage); without this guard it threw "$(...).slick is not a function".
    if (typeof $.fn.slick !== 'function') return;
    if ($('.gallery-thumbnails').hasClass('slick-initialized')) {
      $('.gallery-thumbnails').slick('unslick');
    }
    var totalSlides = $('.gallery-thumbnails > *').length;
    //console.log('totalSlides......',totalSlides);
    $('.gallery-thumbnails').slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      swipe: totalSlides > 6,
      draggable: totalSlides > 6,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 4, slidesToScroll: 1, infinite: true }
        },
        {
          breakpoint: 769,
          settings: { vertical: false, verticalSwiping: false, slidesToShow: 4, slidesToScroll: 1 }
        },
        {
          breakpoint: 480,
          settings: { vertical: false, verticalSwiping: false, slidesToShow: 3, slidesToScroll: 1 }
        },
        {
          breakpoint: 380,
          settings: { vertical: false, verticalSwiping: false, slidesToShow: 3, slidesToScroll: 1 }
        }
      ]
    });

    if (totalSlides <= 6) {

      $('.gallery-thumbnails').addClass('no-arrows');
      $('.gallery-thumbnails').removeClass('yes-arrows');
    } else {
      $('.gallery-thumbnails').addClass('yes-arrows');
      $('.gallery-thumbnails').removeClass('no-arrows');

    }
  }
  runsilder();
  window.runsilder = runsilder;


});



document.addEventListener("DOMContentLoaded", () => {

  //Open code for wishlist app Aj
  if (!document.body.classList.contains('-page')) return;

  const observer = new MutationObserver(() => {
    const wishlist = document.querySelector('#wishlist-hero-shared-list-view');
    if (wishlist) {
      wishlist.classList.add('container-width');
    }

    const copied_text_element = document.querySelector(".wishlist-hero-share-content .wishlist-hero-share-copy-link > span[style*='color: red']");
    if (copied_text_element && !copied_text_element.hasAttribute('data-initialized')) {
      const shouldHide = sessionStorage.getItem('wishlist_copied_hidden');
      if (shouldHide === 'true') {
        copied_text_element.style.display = "none";
      } else {
        copied_text_element.style.display = "none";
      }
      copied_text_element.setAttribute('data-initialized', 'true');
    }

    let wishlist_money = document.querySelectorAll('#wishlist-hero-shared-list-view .money');

    if (wishlist_money.length > 0) {
      wishlist_money.forEach((item) => {
        let text = item.innerText.trim();
        if (text.includes('NGN')) {
          text = text.replace(/NGN/g, '₦');
        }
        if (!text.includes('.')) return;
        const numMatch = text.match(/[\d,]+(\.\d+)?/);
        if (numMatch) {
          const num = parseFloat(numMatch[0].replace(/,/g, ''));
          if (!isNaN(num)) {
            item.innerText = '₦' + Math.round(num).toLocaleString('en-US');
          }
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Handle copy button click Aj
  document.body.addEventListener('click', (e) => {
    if (e.target.closest(".wishlist-hero-share-content .wishlist-hero-share-copy-link button.MuiButtonBase-root")) {

      setTimeout(() => {
        const copied_text_element = document.querySelector(".wishlist-hero-share-content .wishlist-hero-share-copy-link > span[style*='color: red']");
        if (copied_text_element) {
          copied_text_element.style.display = "inline";
          const copied_text = copied_text_element.innerText.trim();
          //console.log("Copied text:", copied_text); 
          setTimeout(() => {
            copied_text_element.style.display = "none";
            sessionStorage.setItem('wishlist_copied_hidden', 'true');
          }, 1000);
        }
      }, 100);
    }

    // if (e.target.closest(".MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root")) {
    //   const button = e.target.closest(".MuiButtonBase-root");
    //   const buttonText = button.textContent.trim().toLowerCase();

    //   if (buttonText === 'ok') {
    //     setTimeout(() => {
    //   const popup_text = document.querySelector(".MuiSnackbar-root.MuiSnackbar-anchorOriginBottomCenter .wishlist-hero-list-footer .MuiSnackbarContent-message #message-id");
    //   console.log("popup_text....", popup_text);
    //   if (popup_text) {
    //     console.log("Message:", popup_text.textContent);
    //   }
    // }, 1500);

    //     console.log('OK button clicked!');

    //   }
    // }
  });

  //close code for wishlist app Aj
});

/* ── Cart quantity input: allow typing, digits only, max 999 ──
   Delegated so it covers both the cart page and the (re-rendered) cart drawer. */
document.addEventListener('input', function (e) {
  var el = e.target;
  if (!el || !el.classList || !el.classList.contains('quantity__input')) return;

  var digits = (el.value || '').replace(/\D/g, '');   // strip non-numeric
  if (digits.length > 3) digits = digits.slice(0, 3);  // max 3 digits
  if (digits !== '' && parseInt(digits, 10) > 999) digits = '999'; // clamp to 999

  if (el.value !== digits) el.value = digits;
});


document.addEventListener("DOMContentLoaded", () => {


  if (
    !document.body.classList.contains('collection-page') &&
    !document.body.classList.contains('search-page')
  ) return;

  //document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".facets__disclosure-vertical").forEach(function (detail) {
    detail.setAttribute("open", true);
  });
  // });
  const cleanFacetLabel = () => {
    const facetButtons = document.querySelectorAll(".active-facets__button-inner");

    if (facetButtons.length > 0) {
      facetButtons.forEach(button => {
        const textNode = Array.from(button.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        // console.log("textNode.........",textNode);
        if (!textNode) return;

        const text = textNode.textContent.trim();
        // console.log("text...",text);
        if (text.startsWith("Everyday_Signature:")) {
          const cleanText = text.replace("Everyday_Signature:", "").trim();
          textNode.textContent = cleanText + " ";
        }
        if (text.startsWith("Color-1:")) {
          const cleanText = text.replace("Color-1", "Colour").trim();
          textNode.textContent = cleanText + " ";
        }
        if (text.includes("₦") && text.includes(".00")) {
          textNode.textContent = text.replace(/\.00/g, "");
        }
      });
    }

  };

  const cleanFilterTitles = () => {
    const labels = document.querySelectorAll(".facets__summary-label");

    labels.forEach(label => {
      const textNode = Array.from(label.childNodes)
        .find(node => node.nodeType === Node.TEXT_NODE);

      if (!textNode) return;

      const text = textNode.textContent.trim();

      // Remove -number from Color-1.
      if (/^Color-\d+$/i.test(text)) {
        textNode.textContent = "Colour";
      }
    });
  };

  const cleanMobileTitles = () => {
    const mobileTitles = document.querySelectorAll(".mobile-link, .mobile_next_link");

    mobileTitles.forEach(title => {
      const text = title.textContent.trim();

      if (/^Color-\d+$/i.test(text)) {
        title.textContent = "Colour";
      }
    });
  };


  const remove_checkbox = () => {
    document.body.addEventListener('click', (e) => {
      const button = e.target.closest('.active-facets__button');
      const remove_all = e.target.closest('.active-facets__button-remove');

      // console.log("remove_all.........", remove_all);
      if (remove_all) {
        const selet_item = document.querySelectorAll(".facets-vertical .facet-checkbox input[type='checkbox']:checked");
        selet_item?.forEach((stItem) => {
          stItem.checked = false;
        });
        return;
      }
      if (!button) return;
      if (button.closest('facet-remove[data-color-key]')) return;

      const buttonInner = button?.querySelector(".active-facets__button-inner");
      //console.log('buttonInner.........',buttonInner);
      const get_value = Array.from(buttonInner.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.textContent)
        .join('')
        .trim();

      //console.log("get_value.....", get_value); 


      if (get_value.includes("₦")) {

        const minPriceInput = document.getElementById('Filter-Price-GTE');
        const maxPriceInput = document.getElementById('Filter-Price-LTE');
        // console.log('minPriceInput...',minPriceInput);
        // console.log('maxPriceInput..',maxPriceInput);
        // window.location.replace(window.location.href);  
        // if (minPriceInput) {
        //   minPriceInput.value = 100;
        // }
        // if(maxPriceInput){
        //   maxPriceInput.value = 3000;
        // }
      } else {
        const parts = get_value.split(':');
        //console.log("parts.....", parts); 
        let afterColon = "";
        if (parts.length > 1) {
          afterColon = get_value.split(':')[1].trim();
          //console.log("afterColon.....", afterColon);
        } else {
          afterColon = get_value.split(':')[0].trim();
          //console.log("afterColon.....", afterColon);
        }


        if (!afterColon) {
          const colorSwatch = buttonInner?.querySelector(".color-swatch-filter");
          if (colorSwatch) {
            afterColon = colorSwatch.getAttribute('color');
            //console.log("afterColon from swatch color.....", afterColon);
          }
        }


        const beforeColon = parts.length > 1 ? parts[0].trim() : '';
        if (beforeColon === 'Availability') {
          const normalizedAvail = afterColon.trim().toLowerCase();
          let availValue = null;
          if (normalizedAvail === 'in stock') availValue = '1';
          else if (normalizedAvail === 'out of stock') availValue = '0';
          if (availValue !== null) {
            document.querySelectorAll(".facets-vertical input[name='filter.v.availability']:checked").forEach((stItem) => {
              if (stItem.value.trim() === availValue) stItem.checked = false;
            });
          }
        }

        const selet_item = document.querySelectorAll(".facets-vertical .facet-checkbox input[type='checkbox']:checked");
        selet_item?.forEach((stItem) => {
          let getSelectValue = stItem.value.trim();
          //console.log('getSelectValue....', getSelectValue);

          if (afterColon === getSelectValue) {
            stItem.checked = false;
            // console.log("checked.............");
          }
        });
      }

    });
  };


  cleanFacetLabel();
  cleanFilterTitles();
  cleanMobileTitles();
  remove_checkbox();

  const observer = new MutationObserver(() => {
    cleanFacetLabel();
    cleanFilterTitles();
    cleanMobileTitles();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const searchPage = document.querySelector('.search-page');
  //console.log(`Search page ...`,searchPage);
  if (searchPage) {

    if (window.innerWidth >= 750) {
      const getundefined = document.querySelector(".cloned-active-facets.container-width");
      // console.log(`getundefined.....${getundefined?.innerText}`);
      if (getundefined?.innerText == 'undefined') {
        getundefined.innerHTML = "No products found<br>Use other keys or <a href='/'>remove all</a>";
        getundefined?.classList.add("no_products");
      }
      else {
        getundefined?.classList.remove("no_products");
      }
    } else {
      const getundefined = document.querySelector(".template-search.template-search--empty");
      // console.log(`getundefined.....${getundefined.innerText}`);
      // console.log(`typeof ....${typeof(getundefined.innerText)}`);
      if (getundefined?.innerText == "") {
        getundefined.innerHTML = "No products found<br>Use other keys or <a href='/'>remove all</a>";
        getundefined?.classList.add("no_products");
      }
      else {
        getundefined?.classList.remove("no_products");
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {

  const formatJdgmAverage = (el) => {
    const val = parseFloat(el.textContent);
    if (!isNaN(val)) {
      const formatted = val.toFixed(1);
      if (el.textContent !== formatted) el.textContent = formatted;
    }
  };

  const badge = document.querySelector('.jdgm-prev-badge[data-number-of-reviews="0"]');
  // console.log("Badge", badge);
  const noReviewsBlock = badge?.closest('.shopify-block.shopify-app-block');

  // console.log("Nor retywreyw", noReviewsBlock);
  if (noReviewsBlock) {
    noReviewsBlock.classList.add('jdgm-no-reviews');
  }

  document.querySelectorAll('.jdgm-rev-widg__summary-average').forEach(formatJdgmAverage);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('.jdgm-rev-widg__summary-average')) formatJdgmAverage(node);
        node.querySelectorAll?.('.jdgm-rev-widg__summary-average').forEach(formatJdgmAverage);
      });
      if (mutation.type === 'characterData') {
        const parent = mutation.target.parentElement;
        if (parent?.classList.contains('jdgm-rev-widg__summary-average')) formatJdgmAverage(parent);
      }
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  const addReadMore = () => {
    document.querySelectorAll('.jdgm-rev__body').forEach((el) => {

      if (el.classList.contains("processed")) return;
      el.classList.add("processed");

      const fullText = el.textContent.trim();

      if (fullText.length > 250) {

        const shortText = fullText.substring(0, 250);

        el.innerHTML = shortText + ' <a href="#" class="read-more-link">... read more</a>';

        el.addEventListener("click", (e) => {

          if (e.target.classList.contains("read-more-link")) {
            e.preventDefault();

            if (el.classList.contains("expanded")) {
              el.innerHTML = shortText + '... <a href="#" class="read-more-link">... read more</a>';
              el.classList.remove("expanded");
            } else {
              el.innerHTML = fullText + ' <a href="#" class="read-more-link">... read less</a>';
              el.classList.add("expanded");
            }
          }

        });

      }

    });

  }

  setTimeout(addReadMore, 2000);

  // Style stars as filled gray when data-score is "0.00" Aj
  // The observer below watches the whole body, so this used to rescan the
  // document synchronously on every DOM change anywhere on the page (apps and
  // sliders make hundreds during load). Badges already done are now skipped,
  // and a burst of mutations is coalesced into one pass per animation frame.
  // Marked per star, not per badge, so stars Judge.me re-renders are recoloured.
  const colorZeroStars = () => {
    document.querySelectorAll('.jdgm-prev-badge__stars[data-score="0.00"] .jdgm-star:not([data-zero-star])').forEach(star => {
      star.setAttribute('data-zero-star', '');
      star.classList.remove('jdgm--off');
      star.classList.add('jdgm--on');
      star.style.color = '#D9D9D9';
    });
  };

  setTimeout(colorZeroStars, 2000);

  let zeroStarsScheduled = false;
  const starObserver = new MutationObserver(() => {
    if (zeroStarsScheduled) return;
    zeroStarsScheduled = true;
    requestAnimationFrame(() => {
      zeroStarsScheduled = false;
      colorZeroStars();
    });
  });
  starObserver.observe(document.body, { childList: true, subtree: true });


  document.addEventListener('click', (e) => {
    document.querySelectorAll('details.store-pickup-details[open]').forEach(function (det) {

      if (!e.target.closest('.store-pickup-panel') && !e.target.closest('summary')) {
        det.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('details.store-pickup-details[open]').forEach(function (det) {
        det.removeAttribute('open');
      });
    }
  });

});


document.addEventListener("DOMContentLoaded", () => {
  if (!window.location.pathname.startsWith("/products/")) return;


  document.body.addEventListener("click", (e) => {
    const swatch = e.target.closest(".product-card__swatch");
    if (!swatch) return;


    if (!swatch.closest(".similar-products, .related-products, .like-products")) return;

    const cardWrapper = swatch.closest(".product-card-wrapper");
    if (!cardWrapper) return;

    const sale_price = swatch.getAttribute("data-variant-price");
    const compare_at_price = swatch.getAttribute("data-variant-compare-at");
    const variant_discount = swatch.getAttribute("data-variant-discount");

    const priceContainer = cardWrapper.querySelector(".price__container");
    if (!priceContainer) return;

    const set_price = priceContainer.querySelector(".price__sale");
    const regular_price = priceContainer.querySelector(".price__regular");

    if (set_price) {

      const price_el = set_price.querySelector(".actual-price") || set_price.querySelector(".price-item--last");
      if (price_el && sale_price) price_el.innerText = sale_price;


      const compare_el = set_price.querySelector(".compare-at-price") || set_price.querySelector("del.compare_at_price");
      if (compare_el) {
        if (!compare_at_price || compare_at_price === "₦0") {
          compare_el.style.display = "none";
        } else {
          compare_el.innerText = compare_at_price;
          compare_el.style.display = "";
        }
      }


      const discount_el = set_price.querySelector(".box-percent") || set_price.querySelector(".price-offer");
      if (discount_el) {
        if (variant_discount && parseInt(variant_discount) > 0) {
          discount_el.innerText = variant_discount + "% OFF";
          discount_el.style.display = "";
        } else {
          discount_el.style.display = "none";
        }
      }
    } else if (regular_price) {

      const price_el = regular_price.querySelector(".actual-price") || regular_price.querySelector(".ppp") || regular_price.querySelector(".price-item--last");
      if (price_el && sale_price) price_el.innerText = sale_price;
    }

    if (typeof updatePerUnitPrice === "function") updatePerUnitPrice(cardWrapper, swatch);

    if (typeof formatPriceElements === "function") formatPriceElements(cardWrapper);
  }, true);

});

// Hide GW branding on all pages (popup can open from collection pages too)
document.addEventListener("DOMContentLoaded", () => {

  const colorbox = document.querySelectorAll('.quick-add .product-card__swatches .product-card__swatch');
  colorbox.forEach((color) => {

    let lable_color = color.getAttribute('aria-label');
    if (lable_color) {
      //console.log('lable_color...', lable_color);
      if (lable_color.toLowerCase().includes('no value')) {
        color.style.display = 'none';
      }
    }

  });

  function hideGwBranding(iframe) {
    let attempts = 0;
    const timer = setInterval(() => {
      attempts++;
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        const branding = iframeDoc.querySelector('.gw-branding-powered-by');
        if (branding) {
          branding.style.setProperty('display', 'none', 'important');
          clearInterval(timer);
        }
      } catch (e) { }
      if (attempts > 100) clearInterval(timer);
    }, 300);
  }

  const gwObserver = new MutationObserver(() => {
    const iframe = document.getElementById('gw-stock-fulfilled-iframe');
    if (iframe && !iframe._gwBrandingHidden) {
      iframe._gwBrandingHidden = true;
      hideGwBranding(iframe);
      iframe.addEventListener('load', () => {
        iframe._gwBrandingHidden = false;
        iframe._gwBrandingHidden = true;
        hideGwBranding(iframe);
      });
    }
  });
  gwObserver.observe(document.body, { childList: true, subtree: true });

});
// Open Show "Clear all" when a filter is selected or sort is changed Aj
document.addEventListener("DOMContentLoaded", () => {
  const syncSortState = () => {
    const sortSelect = document.getElementById('SortBy');
    const defaultSort = sortSelect ? sortSelect.dataset.defaultSort : '';
    const currentSort = new URLSearchParams(window.location.search).get('sort_by')
      || (sortSelect ? sortSelect.value : '');
    const hasSort = Boolean(currentSort) && Boolean(defaultSort) && currentSort !== defaultSort;
    document.body.classList.toggle('has-active-sort', hasSort);
  };
  syncSortState();
  const grid = document.getElementById('ProductGridContainer');
  if (grid) {
    new MutationObserver(syncSortState).observe(grid, { childList: true, subtree: true });
  }
  window.addEventListener('popstate', syncSortState);
});
// Close Show "Clear all" when a filter is selected or sort is changed Aj




